import { cn } from '@/lib/utils'
import { useTranslation } from 'react-i18next'
import whatsappIcon from '@/assets/images/icons/Whatsapp_logo_svg.png'
import type { ChatMessageProps } from '@/types/chatbot'

const WHATSAPP_CONTACTS = {
  general: '+393400000000',
  hr: '+393400000001',
}

export function ChatMessage({ message, isTyping = false }: ChatMessageProps) {
  const { t } = useTranslation('common')
  const isUser = message.role === 'user'

  const handleWhatsAppClick = (phone: string) => {
    window.open(`https://wa.me/${phone.replace(/[^0-9]/g, '')}`, '_blank')
  }

  return (
    <div className={cn('flex flex-col', isUser ? 'items-end' : 'items-start')}>
      <div
        className={cn(
          'max-w-[85%] rounded-2xl px-4 py-2.5',
          isUser
            ? 'bg-gray-900 text-white rounded-br-sm'
            : 'bg-white text-gray-900 rounded-bl-sm shadow-sm'
        )}
      >
        {isTyping ? (
          <div className="flex gap-1.5 py-1 px-1">
            <span
              className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
              style={{ animationDelay: '0ms' }}
            />
            <span
              className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
              style={{ animationDelay: '150ms' }}
            />
            <span
              className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
              style={{ animationDelay: '300ms' }}
            />
          </div>
        ) : (
          <p className="text-sm whitespace-pre-wrap leading-relaxed">
            {message.content}
          </p>
        )}
      </div>

      {/* WhatsApp CTA - only for assistant messages, not typing */}
      {!isUser && !isTyping && message.content && (
        <div className="flex flex-wrap items-center gap-2 sm:gap-3 mt-1.5 ml-1">
          <button
            onClick={() => handleWhatsAppClick(WHATSAPP_CONTACTS.general)}
            className="flex items-center gap-1 text-[10px] sm:text-xs text-gray-500 hover:text-green-600 transition-colors"
          >
            <img src={whatsappIcon} alt="" className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
            <span>{t('whatsapp.roles.generalSupport')}</span>
          </button>
          <button
            onClick={() => handleWhatsAppClick(WHATSAPP_CONTACTS.hr)}
            className="flex items-center gap-1 text-[10px] sm:text-xs text-gray-500 hover:text-green-600 transition-colors"
          >
            <img src={whatsappIcon} alt="" className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
            <span>{t('whatsapp.roles.humanResources')}</span>
          </button>
        </div>
      )}
    </div>
  )
}
